export const CREDIT_ENDPOINT = `https://${process.env.NEXT_PUBLIC_CREDIT_GATEWAY_DOMAIN_NAME}`;
